



































import { defineComponent, PropType } from "@vue/composition-api";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import { occFontLight } from "@/assets/styles/vars-for-script.scss";

export default defineComponent({
  components: {
    OccButton
  },
  name: "FieldController",
  props: {
    orderable: {
      type: Object as PropType<{ raise: boolean; lower: boolean }>,
      default: undefined
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  emits: ["raise", "lower", "delete"],
  setup() {
    return { occFontLight };
  }
});
